// src/utils/CurrencyFormatter.js
import React, { useContext } from 'react';
import { CurrencyContext } from '../contexts/CurrencyContext';
import { FormattedNumber } from 'react-intl';

const CurrencyFormatter = ({ value }) => {
  const { currency } = useContext(CurrencyContext);

  if (currency === 'BDT') {
    return <span>৳{parseFloat(value).toFixed(2)}</span>;
  }

  return (
    <FormattedNumber
      value={value}
      style="currency"
      currency={currency}
      minimumFractionDigits={2}
      maximumFractionDigits={2}
    />
  );
};

export default CurrencyFormatter;
